<div class="wrap">
  <ng-container *ngIf="!openForm; else formTemplate">
    <div class="header">
      <div class="title">
        <fa-icon [icon]="getFaIcon('faChevronLeft')" [routerLink]="['/admin']" routerLinkActive="router-link-active" appChangeColorTheme attribute="color"></fa-icon>
        <h2>Liste des formulaires</h2>
      </div>

      <div class="add-search-form">
        <div class="add-form" (click)="addForm()" (keypress)="addForm()" appChangeColorTheme [isHover]="true">
            <fa-icon [icon]="getFaIcon('faPlus')" appChangeColorTheme attribute="color"></fa-icon>
            <span>Ajouter un formulaire</span>
        </div>
        <div class="search_bar">
          <form [formGroup]="searchForm">
              <input id="" type="text" placeholder="Chercher un formulaire ..." (input)="applyFilter($event.target.value)" formControlName="keyword">
          </form>
          <fa-icon [icon]="getFaIcon('faTimes')" (click)="resetSearch()" (keypress)="resetSearch()" class="faTimes" *ngIf="valueInput" ></fa-icon>
          <fa-icon [icon]="getFaIcon('faSearch')" *ngIf="!valueInput" ></fa-icon>
        </div>
      </div>
    </div>

    <div class="content" [hidden]="isLoading">
      <div class="list-forms mat-elevation-z8">
        <table mat-table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="createdOn">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="createdOn" class="cell_club">Créé le</th>
            <td mat-cell *matCellDef="let element" class="cell_club"> {{element.createdOn | date:'dd/MM/yyyy'}} </td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="name" class="cell_club">Nom</th>
            <td mat-cell *matCellDef="let element" class="cell_club"> {{element.name}} </td>
          </ng-container>

          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="description" class="cell_club">Description</th>
            <td mat-cell *matCellDef="let element" class="cell_club"> {{element.description}} </td>
          </ng-container>

          <ng-container matColumnDef="details">
            <th mat-header-cell *matHeaderCellDef class="cell_action"></th>
            <td mat-cell *matCellDef="let element" class="cell_action">
              <div class="actions">
                <button mat-icon-button (click)="edit(element)" matTooltip="Éditer" matTooltipPosition="above">
                  <mat-icon>edit</mat-icon>
                </button>
                <mat-slide-toggle matTooltip="Activer/Désactiver" matTooltipPosition="above" size="large" (change)="activatedOrDeactivatedFD($event, element)" [color]="color" [checked]="element.enabled"></mat-slide-toggle>
                <button mat-icon-button (click)="deleteFD(element)" matTooltip="Supprimer" matTooltipPosition="above">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
      <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
          (page)="pageEvent = $event" [color]="color">
      </mat-paginator>
    </div>
  </ng-container>

  <ng-template #formTemplate>
    <app-open-dialog-admin-form [formDefinition]="formToEdit"
                               (getOpenForm)="onGetOpenForm($event)"></app-open-dialog-admin-form>
  </ng-template>
</div>
